var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaverBlogBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.571 5.143)",
    style: {
      opacity: 0.4
    },
    "data-name": "\\uADF8\\uB8F9 164270"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 83212",
    d: "M3.791 5.82a.672.672 0 0 0-.671.671.671.671 0 1 0 .671-.671z",
    transform: "translate(.426 .794)",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9432",
    cx: 0.716,
    cy: 0.716,
    r: 0.716,
    transform: "translate(10.069 6.546)",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 83213",
    d: "M16.74 0H2.58A2.585 2.585 0 0 0 0 2.58v8.4a2.578 2.578 0 0 0 2.58 2.58h5l1.7 4s.114.352.4.352c.284 0 .4-.352.4-.352l1.7-4h4.96a2.578 2.578 0 0 0 2.58-2.58v-8.4A2.578 2.578 0 0 0 16.74 0zM6.069 7.421A1.594 1.594 0 0 1 4.478 9a1.344 1.344 0 0 1-.966-.409v.273h-1.16V4.1c.068.011 1.159 0 1.159 0v1.821c.273-.466 1.057-.455 1.057-.455a1.692 1.692 0 0 1 1.501 1.955zM8.1 5.614v3.262H6.967V5.648c0-.443-.546-.557-.546-.557V3.955A1.569 1.569 0 0 1 8.1 5.626zM10.785 9a1.831 1.831 0 0 1-1.9-1.75 1.831 1.831 0 0 1 1.9-1.75 1.831 1.831 0 0 1 1.9 1.75 1.831 1.831 0 0 1-1.9 1.75zm6.194 0a1.619 1.619 0 0 1-1.671 1.659H14.8V9.58h.3s.7.068.7-1.023c0 0-.136.443-1.136.443a1.494 1.494 0 0 1-1.409-1.477V7a1.608 1.608 0 0 1 1.58-1.534 1.145 1.145 0 0 1 .989.443v-.352h1.148V9z",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9433",
    cx: 0.705,
    cy: 0.705,
    r: 0.705,
    transform: "translate(14.479 6.557)",
    style: {
      fill: "#191919"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverBlogBlack);
export default __webpack_public_path__ + "static/media/naver-blog-black.78f81d901eaa2f5aa1bb42c63871d611.svg";
export { ForwardRef as ReactComponent };